import { render, staticRenderFns } from "./AdjustResultBtn.vue?vue&type=template&id=1be36d1a&scoped=true&"
import script from "./AdjustResultBtn.vue?vue&type=script&lang=js&"
export * from "./AdjustResultBtn.vue?vue&type=script&lang=js&"
import style0 from "./AdjustResultBtn.vue?vue&type=style&index=0&id=1be36d1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be36d1a",
  null
  
)

export default component.exports